// Куда вернуть человека после входа (задача D4): `/login?next=…`. Параметр приходит из адреса, поэтому ему не верим:
// открытая переадресация увела бы со входа на чужой сайт.

/** Куда идём, если `next` нет или он не годится: до запуска первый экран — «Готовность». */
export const DEFAULT_PATH_AFTER_LOGIN = '/readiness';

/** Управляющий символ: табуляцию и перевод строки браузер из адреса выбрасывает, и «/\t/evil» становится «//evil». */
function hasControlChar(text: string): boolean {
  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return true;
  }
  return false;
}

/**
 * Путь пульта из `next`: начинается с «/» и не с «//» (и не с «/\», который браузер читает как «//»), остаётся на этом
 * же сайте и не ведёт снова на вход. Иначе — «Готовность».
 */
export function safeNextPath(next: string | null): string {
  if (next === null || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) {
    return DEFAULT_PATH_AFTER_LOGIN;
  }
  if (hasControlChar(next)) return DEFAULT_PATH_AFTER_LOGIN;
  // Разбор тем же парсером, что у браузера: путь, который он понял бы как другой сайт, не пройдёт.
  const url = new URL(next, window.location.origin);
  if (url.origin !== window.location.origin) return DEFAULT_PATH_AFTER_LOGIN;
  if (url.pathname.replace(/\/+$/, '') === '/login') return DEFAULT_PATH_AFTER_LOGIN;
  return `${url.pathname}${url.search}${url.hash}`;
}
